// extracted by mini-css-extract-plugin
export var description = "index-module--description--F8RZ3";
export var keyNumber = "index-module--keyNumber--4xZ4D";
export var value = "index-module--value--ovF-L";
export var whoAreWe = "index-module--whoAreWe--imKed";